import { createActions, createReducer } from 'reduxsauce'
import Immutable from 'seamless-immutable'
import _ from 'lodash'

export const INITIAL_STATE = Immutable({
  data: [],
  loading: false,
})

const { Types, Creators } = createActions({
  setAppInboxesLoading: ['val'],
  setAppInboxes: ['data'],

  deleteAppInbox: ['appInboxId'],

  syncAppInboxes: null,
  unSyncAppInboxes: null,

})

export const setAppInboxesLoadingReducer = state => state.set('loading', true)

export const setAppInboxesReducer = (state, { data }) =>
  state
    .set('data', data)
    .set('loading', false)

export const deleteAppInboxReducer = (state, { appInboxId }) =>
  state.set('data', _.omit(state.data, appInboxId))

export const syncAppInboxesReducer = state => state.set('loading', true)

export const appInboxReducer = createReducer(INITIAL_STATE, {
  [Types.SET_APP_INBOXES]: setAppInboxesReducer,
  [Types.DELETE_APP_INBOX]: deleteAppInboxReducer,
  [Types.SYNC_APP_INBOXES]: syncAppInboxesReducer,
  [Types.SET_APP_INBOXES_LOADING]: setAppInboxesLoadingReducer,
})

export const AppInboxTypes = Types
export default Creators



// WEBPACK FOOTER //
// ./src/reducers/appInboxReducer.js